import React, { Fragment, useEffect, useState } from "react"
import Modal from "react-modal"

import Button from "components/common/Button"

import WarningIcon from "assets/icons/warning.svg"

import "styles/components/common/response-modal.scss"

const IdleModal = ({ isOpen, closeModal, logoutAction, idleMins }) => {
  const [countdown, setCountdown] = useState(10)

  useEffect(() => {
    let timer

    if (isOpen) {
      // Start a countdown timer when the modal is open
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1)
      }, 1000)
    }

    return () => {
      clearInterval(timer)
    }
  }, [isOpen])

  useEffect(() => {
    if (countdown === 0) {
      // Close the modal when the countdown reaches 0
      //add auto logout when not playing video
      logoutAction()
      closeModal()
      setCountdown(10)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown, closeModal])

  const handleClose = () => {
    closeModal()
    setCountdown(10)
  }
  return (
    <Modal
      closeTimeoutMS={1000}
      isOpen={isOpen}
      onRequestClose={handleClose}
      ariaHideApp={false}
      className="response-modal"
      overlayClassName="response-modal-overlay"
    >
      <Fragment>
        <div className="response-modal-container">
          <span className="response-modal-icon">
            <img src={WarningIcon} alt="Warning" />
          </span>
          <span className={`response-modal-header warning`}>
            Your session is about to expire.
          </span>
          <p className="response-modal-message">
            You have been idle for {idleMins}{" "}
            {idleMins > 1 ? "minutes" : "minute"}. The system will log you out
            in
            <strong>{` ${countdown}`}</strong>.<br></br>Click Cancel if you want
            to continue your learning session.
          </p>

          <div className="button-group">
            <Button label="Cancel" onClick={handleClose} />
          </div>
        </div>
      </Fragment>
    </Modal>
  )
}

export default IdleModal
